import React,{useState}from"react";
import{Box,Button,Container,IconButton,InputAdornment,Paper,Stack,TextField,Typography}from"@mui/material";
import{LockOutlined,Visibility,VisibilityOff}from"@mui/icons-material";
import{Navigate,useNavigate}from"react-router-dom";
import{useAuth}from"../context/AuthContext";
import{useAlert}from"../context/AlertContext";

export default function UpdatePassword(){
  const navigate=useNavigate();
  const{user,isAuthenticated,loading:authLoading,authFetch,refreshAccessToken}=useAuth();
  const{showError,showSuccess}=useAlert();
  const[form,setForm]=useState({password:"",confirm_password:""});
  const[showPassword,setShowPassword]=useState(false);
  const[showConfirm,setShowConfirm]=useState(false);
  const[loading,setLoading]=useState(false);

  if(authLoading)return null;
  if(!isAuthenticated)return <Navigate to="/" replace/>;

  const handleChange=(e)=>{
    const{name,value}=e.target;
    setForm(prev=>({...prev,[name]:value}));
  };

  const handleSubmit=async(e)=>{
    e.preventDefault();

    if(!form.password||!form.confirm_password){
      showError("Ingrese y confirme la nueva contraseña.");
      return;
    }

    if(form.password.length<8){
      showError("La contraseña debe tener al menos 8 caracteres.");
      return;
    }

    if(form.password!==form.confirm_password){
      showError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);

    try{
      const response=await authFetch("/api/login/update-password/",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          password:form.password,
          confirm_password:form.confirm_password,
        }),
      });

      const data=await response.json();

      if(!response.ok)throw new Error(data.detail||"No se pudo actualizar la contraseña.");

      await refreshAccessToken();
      showSuccess(data.detail||"Contraseña actualizada correctamente.");
      navigate("/admin-panel",{replace:true});
    }catch(error){
      showError(error.message||"No se pudo actualizar la contraseña.");
    }finally{
      setLoading(false);
    }
  };

  return(
    <Box sx={{minHeight:"100vh",bgcolor:"#f4f6f9",display:"flex",alignItems:"center",justifyContent:"center",px:2,py:4}}>
      <Container maxWidth="xs">
        <Paper variant="outlined" sx={{p:{xs:3,sm:4},borderRadius:3,borderColor:"#dfe4ea",boxShadow:"none",bgcolor:"#fff"}}>
          <Stack spacing={3}>
            <Box sx={{textAlign:"center"}}>
              <Box sx={{width:58,height:58,borderRadius:2.5,bgcolor:"#123f6d",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",mx:"auto",mb:2,fontSize:22,fontWeight:700}}>GS</Box>

              <Typography sx={{fontSize:24,fontWeight:700,color:"#182230"}}>
                Actualizar contraseña
              </Typography>

              <Typography sx={{mt:.7,fontSize:13.5,color:"#667085"}}>
                {user?.first_name?`${user.first_name}, debes crear una nueva contraseña para continuar.`:"Debes crear una nueva contraseña para continuar."}
              </Typography>
            </Box>

            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2.2}>
                <Box>
                  <Typography sx={{mb:.7,fontSize:13.5,fontWeight:700,color:"#344054"}}>
                    Nueva contraseña
                  </Typography>

                  <TextField
                    name="password"
                    type={showPassword?"text":"password"}
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Mínimo 8 caracteres"
                    size="small"
                    fullWidth
                    required
                    autoComplete="new-password"
                    InputProps={{
                      startAdornment:(
                        <InputAdornment position="start">
                          <LockOutlined sx={{fontSize:18,color:"#98a2b3"}}/>
                        </InputAdornment>
                      ),
                      endAdornment:(
                        <InputAdornment position="end">
                          <IconButton type="button" size="small" onClick={()=>setShowPassword(prev=>!prev)} edge="end" sx={{color:"#98a2b3"}}>
                            {showPassword?<VisibilityOff sx={{fontSize:19}}/>:<Visibility sx={{fontSize:19}}/>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{"& .MuiOutlinedInput-root":{borderRadius:2,minHeight:42},"& input":{fontSize:14}}}
                  />
                </Box>

                <Box>
                  <Typography sx={{mb:.7,fontSize:13.5,fontWeight:700,color:"#344054"}}>
                    Confirmar contraseña
                  </Typography>

                  <TextField
                    name="confirm_password"
                    type={showConfirm?"text":"password"}
                    value={form.confirm_password}
                    onChange={handleChange}
                    placeholder="Repita la nueva contraseña"
                    size="small"
                    fullWidth
                    required
                    autoComplete="new-password"
                    InputProps={{
                      startAdornment:(
                        <InputAdornment position="start">
                          <LockOutlined sx={{fontSize:18,color:"#98a2b3"}}/>
                        </InputAdornment>
                      ),
                      endAdornment:(
                        <InputAdornment position="end">
                          <IconButton type="button" size="small" onClick={()=>setShowConfirm(prev=>!prev)} edge="end" sx={{color:"#98a2b3"}}>
                            {showConfirm?<VisibilityOff sx={{fontSize:19}}/>:<Visibility sx={{fontSize:19}}/>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{"& .MuiOutlinedInput-root":{borderRadius:2,minHeight:42},"& input":{fontSize:14}}}
                  />
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="small"
                  disabled={loading}
                  sx={{
                    minHeight:42,
                    borderRadius:2,
                    textTransform:"none",
                    fontWeight:700,
                    fontSize:14,
                    boxShadow:"none",
                    bgcolor:"#123f6d",
                    "&:hover":{bgcolor:"#0d3359",boxShadow:"none"},
                  }}
                >
                  {loading?"Actualizando...":"Actualizar contraseña"}
                </Button>

                <Typography sx={{fontSize:11.5,color:"#98a2b3",textAlign:"center",lineHeight:1.6}}>
                  Por seguridad, la contraseña temporal dejará de funcionar después de este cambio.
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}